/**
 * @file main.tsx
 * @description This is the main entry point for the React application.
 * It uses ReactDOM's createRoot API to render the root App component into the DOM.
 */import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';

// Find the root element in the HTML where the React app will be mounted.
const rootElement = document.getElementById('root');

// Ensure the root element exists before attempting to render the app.
// This is a crucial check for preventing runtime errors if the HTML is misconfigured.
if (!rootElement) {
  throw new Error("Fatal Error: The root element with id 'root' was not found in the DOM. The React application cannot be mounted. Please check your public/index.html file.");
}

// Create a root for the React application using the concurrent mode API.
const root = ReactDOM.createRoot(rootElement);

// Render the application.
// React.StrictMode is a wrapper that checks for potential problems in an application during development.
// It does not render any visible UI and is stripped in production builds.
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);